import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=58cfa2f1&scoped=true&"
import script from "./MenuView.vue?vue&type=script&lang=js&"
export * from "./MenuView.vue?vue&type=script&lang=js&"
import style0 from "./MenuView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cfa2f1",
  null
  
)

export default component.exports